
import React, { useState, useEffect } from "react";
import "./StudentDetails.css";
import { completeProfile } from "../../api/registrationApi"; // ✅ API for students & alumni
import { useNavigate } from "react-router-dom";

function StudentDetails() {
  const navigate = useNavigate();

  // ✅ Load stored user details from localStorage
  const storedUserDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

  const [formData, setFormData] = useState({
    firstName: storedUserDetails.firstName || "",
    lastName: storedUserDetails.lastName || "",
    enrollmentNumber: storedUserDetails.enrollmentNumber || "",
    workEmail: "", 
    password: "",
    confirmPassword: "",
    role: storedUserDetails.role || "student", // ✅ Default to student
    photo: null,
  });

  const [loading, setLoading] = useState(false);
  const [photoError, setPhotoError] = useState(""); // ✅ Error state for photo

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prevData) => ({
      ...prevData,
      photo: file,
    }));
    setPhotoError(""); // ✅ Reset error if photo is selected
  };

  const handleCancelPhoto = () => {
    setFormData((prevData) => ({ ...prevData, photo: null }));
    setPhotoError("Profile picture is required!"); // ✅ Show error when removed
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.photo) {
      setPhotoError("❌ Profile picture is required!");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("❌ Passwords do not match!");
      return;
    }

    setLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append("firstName", formData.firstName);
    formDataToSend.append("lastName", formData.lastName);
    formDataToSend.append("enrollmentNumber", formData.enrollmentNumber);
    formDataToSend.append("workEmail", formData.workEmail);
    formDataToSend.append("password", formData.password);
    formDataToSend.append("role", formData.role);
    formDataToSend.append("photo", formData.photo); // ✅ Ensure photo is included

    try {
      const response = await completeProfile(formDataToSend, formData.role);
      alert(response.message || "✅ Profile submitted successfully!");
      navigate("/", { replace: true });
      window.location.reload();
    } catch (error) {
      alert("❌ Error submitting profile: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const photoPreview = formData.photo ? URL.createObjectURL(formData.photo) : null;

  return (
    <div className="student-details">
      <h1>Student Details Form</h1>
      <form onSubmit={handleSubmit}>
        {/* Photo Upload (Required) */}
        <div className="form-group">
          <div className="photo-placeholder">
            {photoPreview ? (
              <img src={photoPreview} alt="Profile Preview" />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="gray" width="50%" height="50%">
                <circle cx="12" cy="8" r="4" />
                <path d="M2 20c0-5.33 4.33-8 10-8s10 2.67 10 8H2z" />
              </svg>
            )}
          </div>
          <div className="photo-options">
            <label htmlFor="photo-upload" className="upload-btn">
              Upload Photo 
            </label>
            <input
              type="file"
              id="photo-upload"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <button type="button" className="cancel-btn" onClick={handleCancelPhoto} disabled={!formData.photo}>
              Cancel
            </button>
          </div>
          {photoError && <p className="error-text">{photoError}</p>} {/* ✅ Show error if no photo */}
        </div>

        {/* First Name */}
        <div className="form-group">
          <label htmlFor="firstName">First Name:</label>
          <input type="text" id="firstName" name="firstName" value={formData.firstName} readOnly />
        </div>

        {/* Last Name */}
        <div className="form-group">
          <label htmlFor="lastName">Last Name:</label>
          <input type="text" id="lastName" name="lastName" value={formData.lastName} readOnly />
        </div>

        {/* Enrollment Number */}
        <div className="form-group">
          <label htmlFor="enrollmentNumber">Enrollment Number:</label>
          <input type="number" id="enrollmentNumber" name="enrollmentNumber" value={formData.enrollmentNumber} readOnly />
        </div>

        {/* College Email */}
        <div className="form-group">
          <label htmlFor="workEmail">College Email:</label>
          <input
            type="email"
            id="workEmail"
            name="workEmail"
            placeholder="Enter College Email"
            value={formData.workEmail}
            onChange={(e) => setFormData({ ...formData, workEmail: e.target.value })}
            required
          />
        </div>

        {/* Password */}
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter Password"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            required
          />
        </div>

        {/* Confirm Password */}
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
            required
          />
        </div>

        {/* Submit Button */}
        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
}

export default StudentDetails;







